import { Component, Inject, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { Placeholder } from 'collage-designer/stage/placeholder/placeholder';
import { ToolboxService } from './toolbox.service';

export enum ToolboxType {
  static = 'static',
  overlay = 'overlay',
}

@Component({
  template: '',
})
export class ToolboxComponent
{
  @Input() public type: ToolboxType;
  @Input() public displayTitle: boolean = true;
  public placeholder: Placeholder;

  constructor(
      private mir: MatIconRegistry,
      protected sanitizer: DomSanitizer,
      @Inject(ToolboxService) protected toolboxService: ToolboxService)
  {
    this.loadIcon('close');
    this.placeholder = this.toolboxService.placeholder;
  }

  protected loadIcon(icon: string): void
  {
    this.mir.addSvgIcon(
        icon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
            `assets/img/icons/${icon}.svg`));
  }

  public btnOKClick(): void
  {
    this.toolboxService.commitChanges();
  }

  public btnCancelClick(): void
  {
    this.toolboxService.discardChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/toolbox.component.ts